// axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: '/api', // API 기본 URL
    timeout: 0, // 타임아웃 제한 없음
});

export default axiosInstance;
